import React, { useState, useEffect, useRef } from 'react';
import { Table, Card, Input, Button, Space, } from 'antd';
import { AlignCenterOutlined, PicCenterOutlined, SearchOutlined, } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import axios from 'axios';
import * as common from "./Common";
import useInterval from './useInterval';
import { Modal } from 'antd';
import { Alert } from 'antd';

const { Search } = Input;

const NePanKing = () => {
  useEffect(() => {
  }, [])

  const [filtered, setFiltered] = React.useState([]);

  const [head, setHead] = React.useState(null);
  const [totcnt, setTotCnt] = React.useState(null);

  const [lv1_filter, setLv1Filter] = React.useState({});
  const [lv1_filters, setLv1Filters] = React.useState([]);

  const [lv2_filter, setLv2Filter] = React.useState({});
  const [lv2_filters, setLv2Filters] = React.useState([]);

  const [isMobile, setIsMobile] = useState(false);
  const searchInput = useRef(null);
  const [searchText, setSearchText] = React.useState(null);
  const [searchedColumn, setSearchedColumn] = React.useState(null);
  const [state, setState] = useState({ searchText: '', searchedColumn: '' })

  const handleChange = (pagination, filters, sorter) => {
    setLv1Filter(filters);
    setLv2Filter(filters);
  };
  const clearFilters = () => {
    setLv1Filter({});
    setLv2Filter({});
    setFiltered(head);
  };

  // 타이머에 의해 API데이타 가져오기
  /*
  useInterval(() => {
    //console.log("call apis by timer")
    axios.get("/api/v1/nepanking/de").then((response) => {
      //console.log(response.data);
      if (response.data.status === 0) {
      }
      setTotCnt(response.data.data.totcnt);
      setHead(response.data.data.head);

    }).catch(function (error) {

      setTotCnt([]);
      setHead([]);

      if (error.response) {
        // 요청이 전송되었고, 서버는 2xx 외의 상태 코드로 응답했습니다.
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // 요청이 전송되었지만, 응답이 수신되지 않았습니다. 
        // 'error.request'는 브라우저에서 XMLHtpRequest 인스턴스이고,
        // node.js에서는 http.ClientRequest 인스턴스입니다.
        console.log(error.request);
      } else {
        // 오류가 발생한 요청을 설정하는 동안 문제가 발생했습니다.
        console.log('Error', error.message);
      }
      console.log(error.config);
    });
  }, 30000);
  */
 
  function parseLv1Filter(data) {

    // 중복 제거된 z_lv1 값을 추출
    const lv1Values = [...new Set(data.map(item => item.z_lv1))];
    // filters 배열 생성
    const filters = lv1Values.map((val, index) => (
      { text: val, value: val }
    ));
    setLv1Filters(filters);
  }

  function parseLv2Filter(data) {

    // 중복 제거된 z_lv1 값을 추출
    const lv2Values = [...new Set(data.map(item => item.z_lv2))];
    // filters 배열 생성
    const filters = lv2Values.map((val, index) => (
      { text: val, value: val }
    ));
    setLv2Filters(filters);
  }

  React.useEffect(() => {
    axios.get("/api/v1/nepanking/de").then((response) => {
      //console.log(response.data);
      if (response.data.status === 0) {
      }
      setTotCnt(response.data.data.totcnt);
      setHead(response.data.data.head);
      parseLv1Filter(response.data.data.head);
      parseLv2Filter(response.data.data.head);

      setFiltered(response.data.data.head);
    }).catch(function (error) {

      setTotCnt([]);
      setHead([]);

      if (error.response) {
        // 요청이 전송되었고, 서버는 2xx 외의 상태 코드로 응답했습니다.
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // 요청이 전송되었지만, 응답이 수신되지 않았습니다. 
        // 'error.request'는 브라우저에서 XMLHtpRequest 인스턴스이고,
        // node.js에서는 http.ClientRequest 인스턴스입니다.
        console.log(error.request);
      } else {
        // 오류가 발생한 요청을 설정하는 동안 문제가 발생했습니다.
        console.log('Error', error.message);
      }
      console.log(error.config);
    });


    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkIsMobile(); // 컴포넌트가 마운트되었을 때 한 번 실행
    window.addEventListener('resize', checkIsMobile); // 창 크기가 변경될 때마다 실행
    return () => {
      window.removeEventListener('resize', checkIsMobile); // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
    };
  }, []);

  if (!head) return null;

  const columns = [
    {
      title: "수집 일시",
      dataIndex: "z_dt",
      key: "z_dt",
      width: 40,
      sorter: (a, b) => a.z_dt - b.z_dt,
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => common.UnixTimeToStringDateTime(text)
    },
    {
      title: "분류1",
      dataIndex: "z_lv1",
      key: "z_lv1",
      filters: lv1_filters,
      filteredValue: lv1_filter.z_lv1 || null,
      onFilter: (value, record) => record.z_lv1.includes(value),
      width: 100,
    },
    {
      title: "분류2",
      dataIndex: "z_lv2",
      key: "z_lv2",
      filters: lv2_filters,
      filteredValue: lv2_filter.z_lv2 || null,
      onFilter: (value, record) => (
        //console.log(value),
        record.z_lv2.includes(value)
      ),
      width: 100,
    },
    {
      title: "분류3",
      dataIndex: "z_lv3",
      key: "z_lv3",
      width: 100,
    },
    {
      title: "인기검색어",
      dataIndex: "z_keyword",
      key: "z_keyword",
      width: 100,
    },
    {
      title: "검색어 순위",
      dataIndex: "z_rank",
      key: "z_rank",
      width: 40,
      sorter: (a, b) => a.z_rank - b.z_rank,
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: "네이버 상품수",
      dataIndex: "z_naver_qty",
      key: "z_naver_qty",
      width: 30,
      sorter: (a, b) => a.z_naver_qty - b.z_naver_qty,
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => { return record.z_naver_qty.toLocaleString(); },
      align: 'right',
    },
    {
      title: "네이버 수집일",
      dataIndex: "z_naver_last",
      key: "z_naver_last",
      width: 40,
      sorter: (a, b) => a.z_dt - b.z_dt,
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => common.UnixTimeToStringDateTime(text)
    },
    /*
    {
      title: "11번가 상품수",
      dataIndex: "z_st11_qty",
      key: "z_st11_qty",
      width: 30,
      sorter: (a, b) => a.z_st11_qty - b.z_st11_qty,
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => { return record.z_st11_qty.toLocaleString(); },
      align: 'right',
    },
    {
      title: "11번가 수집일",
      dataIndex: "z_st11_last",
      key: "z_st11_last",
      width: 40,
      sorter: (a, b) => a.z_dt - b.z_dt,
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => common.UnixTimeToStringDateTime(text)
    },
    */
  ];

  const handleSearch = (inputValue) => {
    if (!inputValue) {
      return;
    } else {
      //console.log(inputValue);
      axios.post("/api/v1/nepanking/se", {
        keyword: inputValue
      }).then((response) => {
        setFiltered(response.data.data.searched);
      }).catch(e => {
        console.log(e.message);
      });
    }
  };

  const KeywordSearch = value => {
    //console.log("val:" + this.info[0].code);
    return (
      <div>
        <Search
          dropdownMatchSelectWidth={252}
          enterButton="Search"
          size="large" placeholder="키워드를 입력하세요"
          style={{
            width: 320,
          }}
          onSearch={handleSearch}
        >
        </Search>
      </div>
    );
  }

  function showHeadCardTitle() {
    return (
    <div>
      <span> 네이버 판매왕 </span>
      <span style={{ fontWeight: 'lighter' }}>(현재까지 저장된 인기검색어 수는 </span>
      {totcnt && totcnt[0] ? (
        <span style={{ color: 'red', fontWeight: 'lighter' }}>
          {totcnt[0].tot_cnt.toLocaleString()}
        </span>
      ) : (
        <span>-</span>
      )}
      <span style={{ fontWeight: 'lighter' }}> 건 입니다) </span>
    </div>
    );
  }

  return (
    <div>
      <Space
        direction="vertical"
        style={{
          width: '100%',
        }}
      >
        <Alert
          message={
            [
              "'네이버 판매왕'은 네이버 검색어 트랜드의 쇼핑인사트를 분석하여 각 분야 분류별 인기검색어를 수집합니다. ",
              <br />,
              "카테고리는 [분류1 > 분류2 > 분류3] 순으로 구분 되고 마지막으로 분류별 인기검색어를 보여줍니다. 인기검색어는 전일부터 한달간 검색된 순위를 나타냅니다.",
              <br />,
              "그리고 네이버 쇼핑에서 인기검색어에 대한 상품수를 분석한 결과를 보여줍니다. 상품건수가 0인 검색어는 보여지지 않습니다.",
              <br />,
              "각 분류별 인기검색어에 대한 순위는 500위까지 수집을 하고 있으며 화면의 테이블에는 수집된 순위 일부를 보여줍니다. 검색을 통해 전체 데이터에서 조회가 가능합니다.",
              <br />,
              "쇼핑 사이트별 상품건수 데이터를 수집함에 있어 오류가 있을 수도 있으니 참고 바랍니다.",
            ]
          }
          type="info"
          closable

        />
      </Space>
      <div style={{ margin: '14px' }} />
      <Card title={showHeadCardTitle()} size="small" bordered={true}>
        <Space
          style={{
            marginBottom: 12,
          }}
        >
          <Button onClick={clearFilters}>Clear filters</Button>
          <KeywordSearch IterSelectCond="1"/>
        </Space>

        <Table
          bordered
          size="small" scroll={{ x: 1024 }}
          rowKey={common.getUniqueKey}
          dataSource={filtered}
          columns={columns}
          pagination={{ defaultPageSize: common.DEFAULT_PAGE }}
          onChange={handleChange}
        />
      </Card>
    </div>
  )
}

export default NePanKing;

